import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: 'How does PADEL COACH PRO™ work?',
  a: 'After your purchase, you receive immediate digital access to all six modules and five strategic bonuses. Use the resources on your computer, tablet, or smartphone.'
}, {
  q: 'Is this a physical or digital product?',
  a: 'PADEL COACH PRO™ is fully digital. Nothing will be physically shipped. Access is available immediately after payment.'
}, {
  q: 'Is this designed for professional coaches?',
  a: 'Yes. PADEL COACH PRO™ is built for coaches who already understand padel and need professional resources, planning tools, drills, progressions, and ready-to-use sessions.'
}, {
  q: 'Can I use it with different player levels?',
  a: 'Yes. The resources can be adapted according to player ability, training objectives, tactical needs, and competitive level.'
}, {
  q: 'Can I use it for individual, pair, and group training?',
  a: 'Yes. The system includes resources and structures for individual players, pairs, and group sessions.'
}, {
  q: 'Can I adapt the material?',
  a: 'Yes. Every resource provides a professional foundation that you can adapt to your players, coaching methodology, session duration, and objectives.'
}, {
  q: 'Are the five bonuses included?',
  a: 'Yes. During this offer, all five strategic bonuses are included at no additional cost.'
}, {
  q: 'How long will I have access?',
  a: 'Your purchase includes lifetime access to the materials included in your order.'
}, {
  q: 'What makes this different from free online resources?',
  a: 'Free drills and ideas are usually scattered and disconnected. PADEL COACH PRO™ brings planning, drills, sessions, progressions, tactical resources, and player development tools into one professional system.'
}, {
  q: 'What if it is not right for me?',
  a: 'You are protected by a 7-day money-back guarantee. Open the modules, explore the sessions, drills, and bonuses, and if the system is not right for your coaching, contact us within the guarantee period for a full refund.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-ivory px-4 py-8 sm:px-6" data-id="element-67" data-mp="1koovupxxu0cy">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="1fpvgst3061ao">
        <h2 id="faq-title" className="text-center font-display text-3xl uppercase leading-none text-charcoal sm:text-4xl" data-id="element-69" data-mp="2dg8jcm1ki0kr">
          Frequently Asked Questions
        </h2>

        <div className="mt-4 space-y-1.5" data-id="element-70" data-mp="23gzrbyq9iw11">
          {FAQS.map((item, index) => {
          const isOpen = open === index;
          return <div key={item.q} className="overflow-hidden rounded-lg border border-charcoal/10 bg-white" data-id="element-71" data-mp="1zfnxti49pqnk" data-mpi={index}>
                <h3 data-id="element-72" data-mp="o0iv4e44zs3y">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left font-head text-[13px] font-semibold text-charcoal sm:text-base" data-id="element-73" data-mp="nzzauqr0krmr">
                    {item.q}
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-brand transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-74" data-mp="3dgke7qnwf566" />
                  </button>
                </h3>
                {isOpen && <p className="border-t border-charcoal/10 px-3.5 py-2.5 text-[13px] leading-snug text-softgray" data-id="element-75" data-mp="3rf1wh8v1bpgp">
                    {item.a}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}